import { axiosInstance } from "../client";
import { FAQ } from "@rumble-it/common-lib/types/models/FAQ.interface.ts";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import { FaqInputDto } from "../../../pages/admin/faq/components/FaqFormCard";

export const fetchFaqs = async (
  params: PaginationParams,
): Promise<CollectionResponse<FAQ>> =>
  axiosInstance.get(`/admin/faq`, { params }).then((response) => response.data);

export const fetchFaqById = async (id: string): Promise<FAQ> =>
  axiosInstance.get(`/admin/faq/${id}`).then((response) => response.data);

export const createFaq = async (data: FaqInputDto): Promise<null> =>
  axiosInstance.post(`/admin/faq`, data).then((response) => response.data);

export const updateFaqById = async (
  id: string,
  data: FaqInputDto,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/faq/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteFaqById = async (id: string): Promise<null> =>
  axiosInstance.delete(`/admin/faq/${id}`).then((response) => response.data);
